export const LOG_SOURCE = 'web-mi-cuenta'
export const LOG_MESSAGE_OBJECT = (action, error, data) => {
    return {
        source: LOG_SOURCE,
        action: action,
        message: typeof error === 'object' && Object.keys(error).length > 0 ? JSON.stringify(error): error.message,
        stack: typeof error === 'object' && Object.keys(error).length > 0 ? JSON.stringify(error): error.stack,
        data: data
    }
}